var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconUtilities48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2589_10883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.725 42.5029V22.5117L24 34.0653L7.125 22.5117V42.5029H40.725Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19.4819L7.125 22.4985L23.925 34.0656L23.9354 34.0584L12 25.8156L12 19.4819ZM36.0001 25.7517L40.725 22.4985L36.0001 19.5748V25.7517Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19.4819L12.6 19.4819C12.6 19.2643 12.4822 19.0637 12.2921 18.9578C12.1019 18.8519 11.8694 18.8572 11.6843 18.9717L12 19.4819ZM7.125 22.4985L6.80929 21.9882C6.63698 22.0949 6.53013 22.2812 6.52518 22.4838C6.52023 22.6864 6.61785 22.8777 6.78474 22.9927L7.125 22.4985ZM23.925 34.0656L23.5847 34.5598C23.7896 34.7008 24.0604 34.7008 24.2653 34.5597L23.925 34.0656ZM23.9354 34.0584L24.2757 34.5526C24.4382 34.4407 24.5353 34.2561 24.5354 34.0588C24.5355 33.8615 24.4387 33.6768 24.2764 33.5647L23.9354 34.0584ZM12 25.8156L11.4 25.8156C11.4 26.0127 11.4968 26.1972 11.659 26.3093L12 25.8156ZM36.0001 25.7517H35.4001C35.4001 25.9746 35.5236 26.1791 35.7209 26.2828C35.9182 26.3865 36.1567 26.3723 36.3403 26.2459L36.0001 25.7517ZM40.725 22.4985L41.0653 22.9927C41.2321 22.8777 41.3298 22.6864 41.3248 22.4838C41.3199 22.2812 41.213 22.0949 41.0407 21.9882L40.725 22.4985ZM36.0001 19.5748L36.3158 19.0646C36.1307 18.9501 35.8981 18.9447 35.708 19.0507C35.5179 19.1566 35.4001 19.3572 35.4001 19.5748H36.0001ZM11.6843 18.9717L6.80929 21.9882L7.44071 23.0087L12.3157 19.9922L11.6843 18.9717ZM6.78474 22.9927L23.5847 34.5598L24.2653 33.5714L7.46526 22.0043L6.78474 22.9927ZM24.2653 34.5597L24.2757 34.5526L23.5951 33.5642L23.5847 33.5714L24.2653 34.5597ZM24.2764 33.5647L12.341 25.3219L11.659 26.3093L23.5944 34.5521L24.2764 33.5647ZM12.6 25.8156L12.6 19.4819L11.4 19.4819L11.4 25.8156L12.6 25.8156ZM36.3403 26.2459L41.0653 22.9927L40.3847 22.0043L35.6598 25.2575L36.3403 26.2459ZM41.0407 21.9882L36.3158 19.0646L35.6843 20.085L40.4093 23.0087L41.0407 21.9882ZM35.4001 19.5748V25.7517H36.6001V19.5748H35.4001Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 6.50293L36.0001 6.50293V25.7461L24.0001 34.1029L12 25.8154L12.0001 6.50293Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0137 12.9561H20.0711",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0137 10.1978H24.1171",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5564 10.9028V17.3028H33.0149L27.2784 26.1028V19.7028H24.8198L30.5564 10.9028Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_10883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconUtilities48);
export default __webpack_public_path__ + "static/media/pictogramBeaconUtilities48.0d6e2a454b29b329212042f73d791a9b.svg";
export { ForwardRef as ReactComponent };